function sponsor_Reducer(state = [], action) {
    switch (action.type) {
        case 'SPONSOR/SET':
            return action.sponsor;
        case 'SPONSOR/CLEAR':
            return null;
        default:
            return state;
    }
}

export default sponsor_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/sponsor.js